var _style, _g, _g2, _polygon, _rect, _path, _rect2, _path2, _rect3, _polygon2, _rect4, _path3, _rect5, _polygon3, _rect6, _path4, _rect7, _rect8, _rect9, _path5, _rect0, _polygon4, _rect1, _path6, _rect10, _path7, _defs, _defs2, _rect11, _path8, _rect12, _path9, _rect13, _path0, _rect14, _path1, _rect15, _polygon5, _rect16, _rect17, _rect18, _polygon6, _rect19, _path10, _rect20, _polygon7, _rect21, _rect22, _rect23, _path11, _rect24, _polygon8, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs0, _defs1, _rect25, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWftologo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 237.7 61",
    style: {
      enableBackground: "new 0 0 237.7 61"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;}\n\t.st2{clip-path:url(#SVGID_00000021115506772585542940000003790600626034282892_);fill:#FFFFFF;}\n\t.st3{clip-path:url(#SVGID_00000062888422881293623620000015427026775671873973_);fill:#FFFFFF;}\n\t.st4{clip-path:url(#SVGID_00000019659711269050744920000008301162777097615757_);fill:#034EA2;}\n\t.st5{clip-path:url(#SVGID_00000084495638600628770500000009311496787499259284_);fill:#00AB4E;}\n\t.st6{clip-path:url(#SVGID_00000033352078183558836880000012399646037924562054_);fill:#00AB4E;}\n\t.st7{clip-path:url(#SVGID_00000171706612848182585900000010025532775496179108_);fill:#44C8F5;}\n\t.st8{clip-path:url(#SVGID_00000116954587755036925920000016019228759968349858_);fill:#44C8F5;}\n\t.st9{clip-path:url(#SVGID_00000071535255328401806120000002788477627346901149_);fill:#2F7DC1;}\n\t.st10{clip-path:url(#SVGID_00000035495885058887597310000010084699872915208098_);fill:#8DC63F;}\n\t.st11{clip-path:url(#SVGID_00000034768356490449201840000010544714280058208909_);fill:#8DC63F;}\n\t.st12{clip-path:url(#SVGID_00000116928939300889350580000000860380462974717628_);fill:#2F7DC1;}\n\t.st13{fill:#034EA2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.2,26v-5.3h-5V26H80V14.4h2.2v4.4h5v-4.4h2.2V26H87.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.2,26.2c-3,0-4.3-2.4-4.3-4.4s1.3-4.3,4.2-4.3c1.8,0,4.2,1.2,4.2,4.3C100.3,24,98.9,26.2,96.2,26.2z  M96.2,24.4c1.4,0,2.1-1.2,2.1-2.5s-0.7-2.6-2.2-2.6c-1.1,0-2.1,0.8-2.1,2.5C93.9,23.2,94.7,24.4,96.2,24.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.6,17.8v0.9c0.3-0.5,1.3-1.2,2.6-1.2c0.9,0,1.8,0.4,2.3,1.2c0.5-0.7,1.4-1.2,2.6-1.2 c1.7,0,2.8,0.9,2.8,2.8V26h-2v-5c0-0.3-0.1-1.6-1.4-1.6c-0.3,0-1,0.1-1.5,0.8c-0.4,0.6-0.4,1.3-0.4,1.9V26h-2v-5 c0-0.6-0.3-1.6-1.3-1.6c-0.2,0-0.6,0-1,0.4c-0.8,0.7-0.8,1.8-0.8,2.8V26h-2v-8.2H104.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119.2,22.3c0,0.4,0.4,2,2.3,2c1.4,0,2-0.9,2.2-1.1l1.7,1c-0.7,0.9-1.9,2.1-4,2.1c-2.4,0-4.2-1.7-4.2-4.4 c0-2.9,2-4.3,4.1-4.3c3.1,0,4,2.5,4,4.7H119.2z M123.1,20.8c0-0.4-0.3-1.7-1.8-1.7c-1.6,0-1.9,1.4-2,1.7H123.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M136.7,26.2c-3,0-4.3-2.4-4.3-4.4s1.3-4.3,4.2-4.3c1.8,0,4.2,1.2,4.2,4.3C140.8,24,139.5,26.2,136.7,26.2z  M136.7,24.4c1.4,0,2.1-1.2,2.1-2.5s-0.7-2.6-2.2-2.6c-1.1,0-2.1,0.8-2.1,2.5C134.4,23.2,135.3,24.4,136.7,24.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M145.3,19.2V26h-2v-6.8h-1.2v-1.4h1.2v-1.1c0-1.4,0.4-2.3,2.6-2.3c0.4,0,0.7,0,1.1,0.1v1.7c0,0-0.4,0-0.6,0 c-1.1,0-1.2,0.6-1.2,1.1v0.6h1.8v1.4h-1.7V19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M156.7,16.3v2.9h4.8v1.9h-4.8V26h-2.2V14.4h7.7v1.9H156.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M168.6,26v-0.6c-0.5,0.4-1.4,0.8-2.4,0.8c-1.9,0-3-1.1-3-2.5c0-1.8,1.4-2.5,2.9-2.8c1.2-0.2,2-0.4,2.5-0.6 c0-0.6-0.2-1.2-1.4-1.2c-1.5,0-1.7,0.8-1.7,1.2l-2-0.1c0-0.5,0.1-2.6,3.6-2.6c2.4,0,3.4,0.9,3.4,2.3v4.8c0,0.6,0,0.8,0.4,1.3 C170.9,26,168.6,26,168.6,26z M168.6,21.9c-0.3,0.2-0.8,0.3-1.6,0.5c-0.9,0.1-1.8,0.3-1.8,1.1c0,0.5,0.4,1,1.3,1c0.9,0,2-0.5,2-1.5 v-1.1H168.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M173.4,16.5v-2h2v2H173.4z M173.4,26v-8.2h2V26H173.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180,17.8V19c0.6-1.3,2.1-1.3,2.4-1.3h0.2v2c-0.4,0-2,0-2.5,1.5c-0.1,0.5-0.1,0.9-0.1,1.3V26h-1.9v-8.2H180z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.6,16.3V26h-2.2v-9.6h-3.2v-2h8.5v2h-3.1V16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M200.4,17.8V19c0.6-1.3,2.1-1.3,2.4-1.3h0.2v2c-0.4,0-2,0-2.5,1.5c-0.1,0.5-0.1,0.9-0.1,1.3V26h-1.9v-8.2 H200.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209.8,26v-0.6c-0.5,0.4-1.4,0.8-2.4,0.8c-1.9,0-3-1.1-3-2.5c0-1.8,1.4-2.5,2.9-2.8c1.2-0.2,2-0.4,2.5-0.6 c0-0.6-0.2-1.2-1.4-1.2c-1.5,0-1.7,0.8-1.7,1.2l-2-0.1c0-0.5,0.1-2.6,3.6-2.6c2.4,0,3.4,0.9,3.4,2.3v4.8c0,0.6,0,0.8,0.4,1.3 C212.1,26,209.8,26,209.8,26z M209.8,21.9c-0.3,0.2-0.8,0.3-1.6,0.5c-0.9,0.1-1.8,0.3-1.8,1.1c0,0.5,0.4,1,1.3,1c0.9,0,2-0.5,2-1.5 v-1.1H209.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M220,26v-0.8c-0.2,0.2-0.8,1-2.3,1c-1.7,0-3.6-1.2-3.6-4.2c0-2.9,1.8-4.5,3.7-4.5c0.7,0,1.7,0.2,2.2,0.9v-4.1 h2V26H220z M218.1,24.4c1.1,0,1.9-0.9,1.9-2.4c0-1.2-0.4-2.7-1.9-2.7c-1.2,0-2,1.1-2,2.5C216.2,23,216.7,24.4,218.1,24.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M226.4,22.3c0,0.4,0.4,2,2.3,2c1.4,0,2-0.9,2.2-1.1l1.7,1c-0.7,0.9-1.9,2.1-4,2.1c-2.4,0-4.2-1.7-4.2-4.4 c0-2.9,2-4.3,4.1-4.3c3.1,0,4,2.5,4,4.7H226.4z M230.3,20.8c0-0.4-0.3-1.7-1.8-1.7c-1.6,0-1.9,1.4-2,1.7H230.3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80,45.7V34.1h8.2V36h-6.1v2.7h5.6v1.9h-5.6v3.1h6.5v2H80z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.6,37.4v1c0.7-1.1,2.2-1.2,2.5-1.2c1.7,0,2.7,1.1,2.7,2.7v5.7h-1.9V41c0-0.9-0.2-1.9-1.4-1.9 c-0.2,0-0.6,0-1,0.4c-0.6,0.5-0.8,1.2-0.8,2.6v3.6h-2v-8.2L92.6,37.4L92.6,37.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.5,37.4h1.2v-2.9h2v2.9h1.8v1.4h-1.8v4.1c0,0.3,0,0.7,0.2,0.9s0.7,0.2,0.7,0.2c0.3,0,0.6,0,0.8-0.1v1.7 c-0.3,0-0.7,0.1-1.4,0.1c-1.8,0-2.3-0.6-2.3-2v-4.9h-1.2C99.5,38.8,99.5,37.4,99.5,37.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.9,41.9c0,0.4,0.4,2,2.3,2c1.4,0,2-0.9,2.2-1.1l1.7,1c-0.7,0.9-1.9,2.1-4,2.1c-2.4,0-4.2-1.7-4.2-4.4 c0-2.9,2-4.3,4.1-4.3c3.1,0,4,2.5,4,4.7H107.9z M111.8,40.5c0-0.4-0.3-1.7-1.8-1.7c-1.6,0-1.9,1.4-2,1.7H111.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.1,37.4v1.2c0.6-1.3,2.1-1.3,2.4-1.3h0.2v2c-0.4,0-2,0-2.5,1.5c-0.1,0.5-0.1,0.9-0.1,1.3v3.5h-1.9v-8.2 H118.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.6,37.4v0.7c0.3-0.3,1-1,2.2-1c0.5,0,1.7,0.1,2.6,1.2c0.4,0.5,1.1,1.6,1.1,3.2c0,0.4,0,1.7-0.8,2.8 c-1,1.4-2.3,1.5-2.9,1.5c-0.5,0-1.3-0.1-2.2-0.9v3.3h-2V37.4H124.6z M126.6,39.1c-1.4,0-2,1.3-2,2.4c0,1.4,0.7,2.5,2,2.5 c0.8,0,2-0.5,2-2.5C128.6,39.8,127.5,39.1,126.6,39.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M134.8,37.4v1.2c0.6-1.3,2.1-1.3,2.4-1.3h0.2v2c-0.4,0-2,0-2.5,1.5c-0.1,0.5-0.1,0.9-0.1,1.3v3.5h-1.9v-8.2 H134.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.4,36.2v-2h2v2H139.4z M139.4,45.7v-8.2h2v8.2H139.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149.5,40c-0.4-0.9-1.3-1.2-2.2-1.2c-0.4,0-1.4,0.1-1.4,0.9c0,0.5,0.5,0.7,1.7,0.9l1.3,0.2 c1.2,0.2,2.2,1,2.2,2.3c0,1.5-1.4,2.8-3.7,2.8s-3.5-1-3.9-1.5l1.5-1.2c0.4,0.5,1.1,1.1,2.4,1.1c1.2,0,1.6-0.6,1.6-1 c0-0.5-0.5-0.7-1.2-0.8l-1-0.2c-0.6-0.1-2.9-0.5-2.9-2.5c0-1.6,1.6-2.7,3.5-2.7c0.6,0,2.3,0.1,3.5,1.5L149.5,40z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M154.9,41.9c0,0.4,0.4,2,2.3,2c1.4,0,2-0.9,2.2-1.1l1.7,1c-0.7,0.9-1.9,2.1-4,2.1c-2.4,0-4.2-1.7-4.2-4.4 c0-2.9,2-4.3,4.1-4.3c3.1,0,4,2.5,4,4.7H154.9z M158.8,40.5c0-0.4-0.3-1.7-1.8-1.7c-1.6,0-1.9,1.4-2,1.7H158.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M168.6,40c-0.4-0.9-1.3-1.2-2.2-1.2c-0.4,0-1.4,0.1-1.4,0.9c0,0.5,0.5,0.7,1.7,0.9l1.3,0.2 c1.2,0.2,2.2,1,2.2,2.3c0,1.5-1.4,2.8-3.7,2.8s-3.5-1-3.9-1.5l1.5-1.2c0.4,0.5,1.1,1.1,2.4,1.1c1.2,0,1.6-0.6,1.6-1 c0-0.5-0.5-0.7-1.2-0.8l-1-0.2c-0.6-0.1-2.9-0.5-2.9-2.5c0-1.6,1.6-2.7,3.5-2.7c0.6,0,2.3,0.1,3.5,1.5L168.6,40z"
  }))), /*#__PURE__*/React.createElement("g", null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0.4,27.6 5,28.5 5,28.5 0.4,29.3 0.4,30.4 4.9,31.4 4.9,31.4 0.3,32.2 0.3,33.3 6.2,32.2 6.2,30.9  2,29.9 2,29.9 6.3,29.1 6.3,27.8 0.4,26.5  "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 61.1,
    height: 61
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.9,19.9c1.6,0.5,2.7,1.9,2.2,3.7c-0.5,1.7-2.2,2.4-3.9,1.9C1.6,25,0.5,23.6,1,21.8 C1.5,20.1,3.2,19.5,4.9,19.9 M3.6,24.4c1,0.3,2.2,0.1,2.5-1c0.3-1.2-0.5-1.9-1.6-2.2c-1-0.3-2.2-0.1-2.5,1S2.6,24.1,3.6,24.4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 61.1,
    height: 61
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.1,17l1.2-2.1C5,13.8,6,13.5,6.9,14c1.1,0.7,1,1.6,0.9,1.9l2.7,0.1l-0.6,1.1L7.4,17l-0.5,0.9L8.8,19l-0.6,1 L3.1,17z M6.1,17.4l0.6-1c0.3-0.5,0.2-1-0.3-1.3S5.5,15,5.1,15.6l-0.5,0.9L6.1,17.4z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 61.1,
    height: 61
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "7,11 7.8,10.2 11.3,13.6 13,11.8 13.7,12.5 11.3,15.1  "
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 61.1,
    height: 61
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11,7l1.7-1.2c1.7-1.2,3.1-0.7,4.1,0.7c1.1,1.6,0.9,2.9-0.5,4l-1.9,1.3L11,7z M14.7,10.3l0.8-0.6 c0.9-0.6,1.1-1.3,0.3-2.5c-0.7-0.9-1.5-1.3-2.5-0.6l-0.8,0.6L14.7,10.3z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 61.1,
    height: 61
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "21.8,1.2 25.5,0.3 25.8,1.3 23.1,2 23.4,3.4 25.8,2.8 26,3.7 23.6,4.3 24.2,6.7 23.1,7  "
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 61.1,
    height: 61
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.8,0h1.3l2.2,5.8h-1.2l-0.4-1.1l-2.2,0.1L28.2,6H27L28.8,0z M29.5,1.1L29.5,1.1l-0.7,2.7l1.6-0.1L29.5,1.1z "
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 30.2,
    y: -20.2,
    transform: "matrix(0.1307 -0.9914 0.9914 0.1307 42.5675 69.2458)",
    className: "st1",
    width: 61.1,
    height: 61
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 31.2,
    y: 2.7,
    transform: "matrix(0.1307 -0.9914 0.9914 0.1307 26.4881 36.6201)",
    className: "st0",
    width: 5.9,
    height: 1.1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 61.1,
    height: 61
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.9,0.8l2.3,0.7c1.2,0.4,1.7,1.3,1.4,2.3c-0.4,1.3-1.3,1.3-1.6,1.3l0.5,2.7l-1.2-0.4L38.8,5l-1-0.3l-0.7,2.1 L36,6.5L37.9,0.8z M38.1,3.8l1.2,0.4c0.5,0.2,1,0,1.2-0.5s-0.1-1-0.8-1.2l-1-0.3L38.1,3.8z"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 61.1,
    height: 61
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "48.4,7 47.1,6 47.7,5.2 51.1,7.9 50.5,8.7 49.2,7.7 46.2,11.5 45.3,10.8  "
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 61.1,
    height: 61
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.6,9.4l1.6,1.9c0.8,1,0.7,2-0.1,2.7c-1,0.9-1.8,0.4-2.1,0.2l-1,2.5l-0.8-1l0.9-2.3l-0.7-0.8L48.8,14 l-0.7-0.9L52.6,9.4z M51.2,12l0.8,0.9c0.4,0.4,0.9,0.5,1.3,0.2c0.4-0.3,0.4-0.8,0-1.4l-0.7-0.8L51.2,12z"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 61.1,
    height: 61
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.6,16.4l0.6,1.2L53.8,22l-0.5-1l0.9-0.8l-1-2L52,18.3l-0.5-1L57.6,16.4z M56.9,17.5L56.9,17.5L54.1,18 l0.7,1.5L56.9,17.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 61.1,
    height: 61
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000050664566237752538350000009238249331870226841_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000050664566237752538350000009238249331870226841_)",
      fill: "#FFFFFF"
    },
    d: "M59.8,21.6l0.4,2 c0.4,2-0.6,3.1-2.3,3.5c-1.9,0.4-3.1-0.3-3.5-2l-0.5-2.2L59.8,21.6z M55.3,23.7l0.2,1c0.2,1.1,0.8,1.6,2.2,1.2 c1.1-0.2,1.8-0.9,1.5-2.1l-0.2-1L55.3,23.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000163759417887083000980000003419392352151444658_",
    width: 61.1,
    height: 61
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000132063409417186501800000005209273453265024692_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000163759417887083000980000003419392352151444658_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000132063409417186501800000005209273453265024692_)",
      fill: "#FFFFFF"
    },
    points: "61.1,28.7  61,32.9 60,32.9 60,29.8 58.7,29.8 58.7,32.6 57.7,32.6 57.7,29.8 56.2,29.8 56.1,33.1 55.1,33.1 55.2,28.7  "
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 61.1,
    height: 61
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.7,44.6c-1.5,0.7-3.2,0.3-3.9-1.2c-0.7-1.6,0.1-3.1,1.6-3.8s3.2-0.3,3.9,1.2C9,42.4,8.2,43.9,6.7,44.6  M4.8,40.6c-0.9,0.4-1.6,1.3-1.2,2.3C4.1,44,5.3,44,6.2,43.6s1.6-1.3,1.2-2.3C6.9,40.2,5.7,40.2,4.8,40.6"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 61.1,
    height: 61
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.9,44.2l1.5,1.9c0.8,1,0.6,2-0.2,2.6c-1,0.8-1.8,0.3-2.1,0.2l-1,2.5l-0.8-1l1-2.2l-0.6-0.8L6,48.6l-0.7-0.9 L9.9,44.2z M8.4,46.7l0.7,0.9c0.3,0.4,0.8,0.6,1.3,0.2c0.4-0.3,0.5-0.8,0-1.4l-0.6-0.8L8.4,46.7z"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 61.1,
    height: 61
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.2,52.4c0.2-0.4,0.3-1.2-0.5-1.8c-0.9-0.7-1.9-0.2-2.6,0.6c-0.6,0.8-0.9,1.9,0,2.6c0.6,0.5,1.5,0.5,2-0.1 L13,52.8l0.6-0.8l1.9,1.5l-2,2.5l-0.7-0.6l0.3-0.4c-0.6,0.1-1.2-0.1-1.6-0.4c-1.5-1.2-1.3-2.8-0.3-4.1s2.7-1.8,4.1-0.7 c0.9,0.7,1.2,1.7,0.9,2.9L15.2,52.4z"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 61.1,
    height: 61
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.5,52.6l1.2,0.5L20,59.2l-1-0.5l0.2-1.2l-2-0.9l-0.8,0.9l-1-0.5L19.5,52.6z M19.7,53.8L19.7,53.8l-1.9,2.1 l1.5,0.7L19.7,53.8z"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 61.1,
    height: 61
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "23.2,54.2 24.2,54.4 25.8,59 25.8,59 26.6,54.9 27.6,55.1 26.4,60.8 25.4,60.6 23.9,56 23.9,56  23,60.1 22,59.9  "
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: -28.3,
    y: 26.1,
    transform: "matrix(2.833027e-02 -0.9996 0.9996 2.833027e-02 -54.3558 57.2265)",
    className: "st1",
    width: 61.1,
    height: 61
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 26.9,
    y: 57.6,
    transform: "matrix(2.833027e-02 -0.9996 0.9996 2.833027e-02 -29.1472 86.22)",
    className: "st0",
    width: 5.8,
    height: 1.1
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 61.1,
    height: 61
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "32.4,60.1 35,55.8 32.2,56.2 32,55.2 36.2,54.6 36.4,55.6 33.8,59.9 36.9,59.4 37.1,60.4 32.6,61  "
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 61.1,
    height: 61
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.5,53.9l1.2-0.4l3.8,4.8l-1.1,0.4l-0.7-0.9l-2.1,0.8l0.1,1.2l-1,0.2L38.5,53.9z M39.5,54.7L39.5,54.7 l0.2,2.8l1.5-0.6L39.5,54.7z"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 61.1,
    height: 61
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "43.3,52.8 42,53.6 41.5,52.8 45.1,50.5 45.6,51.4 44.3,52.2 46.8,56.3 45.9,56.9  "
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: -9.4,
    y: 16.5,
    transform: "matrix(0.7644 -0.6448 0.6448 0.7644 -25.2882 24.7064)",
    className: "st1",
    width: 61.1,
    height: 61
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 47.8,
    y: 48.7,
    transform: "matrix(0.7644 -0.6448 0.6448 0.7644 -21.8755 43.3478)",
    className: "st0",
    width: 1.1,
    height: 5.8
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 61.1,
    height: 61
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.6,45.9c1.3,1,1.7,2.7,0.6,4.1c-1.1,1.3-2.9,1.3-4.1,0.2c-1.3-1-1.7-2.7-0.6-4.1 C50.6,44.8,52.4,44.9,53.6,45.9 M50.8,49.3c0.8,0.6,1.9,0.9,2.6,0c0.7-0.9,0.2-1.9-0.5-2.6c-0.8-0.6-1.9-0.9-2.6,0 C49.5,47.6,50,48.7,50.8,49.3"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 61.1,
    height: 61
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "51.9,43.1 52.4,42.2 57.1,41.7 57.1,41.7 53.4,39.9 53.8,39 59.1,41.5 58.7,42.4 53.9,42.9 53.9,42.9  57.6,44.6 57.2,45.5  "
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000027573049058270197640000017475654377060670601_",
    width: 61.1,
    height: 61
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000134966153143752311760000011375579397965063823_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000027573049058270197640000017475654377060670601_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000134966153143752311760000011375579397965063823_)",
      fill: "#034EA2"
    },
    d: "M41.7,43.8 c0.4-0.9,1.9-1,2.5-0.6c1,0.8-5,5.1-2.3,5.6c2.4,0.5,9.8-8.2,8.8-10.8c-0.9-2.3-3.2-2.4-4.1-4c-2.3-4,4.9-6.3,2.1-8.2 c-1.9-1.3-4.1-0.5-6.1,1.1c-3.5,2.7,1.9,8.4-1.6,11.1c-2.2,1.7-4.9-0.1-6.8-2.2c-2.9-3-9.2-4.4-9.5-1.3c-0.2,1.4,0.9,2.3,2,3.2 c3.7,2.7,10.7,2,10.6,5.7c0,1.7,0.1,3.2-1.2,4.2c-1.7,1.3-3.7-0.4-5.4,0.9c-0.7,0.5-0.6,1.6-0.1,2.3c0.6,0.8,1.7,1.3,2.9,1.3 C36.5,52.1,39.8,47.8,41.7,43.8"
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000108294598991193944390000015626959032867336860_",
    width: 61.1,
    height: 61
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013167997301999866000000016984927702687462791_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000108294598991193944390000015626959032867336860_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000013167997301999866000000016984927702687462791_)",
      fill: "#00AB4E"
    },
    d: "M28.7,48.5 c-2.5-2.4-6,0.7-4.1,2.6C28.2,54.9,30,49.8,28.7,48.5"
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000041295134404209932520000008223750558715837345_",
    width: 61.1,
    height: 61
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000163048376670890009790000018368318812671396029_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000041295134404209932520000008223750558715837345_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000163048376670890009790000018368318812671396029_)",
      fill: "#00AB4E"
    },
    d: "M33.9,42.6 c1,0.7,1.7,1.3,1.4,2.6c-0.7,2.9-8.4-1.4-11.8,1.3c-1.2,0.9-0.4,3-1.5,3.9c-0.6,0.5-1.5,0.2-2-0.6c-0.7-1.1-0.4-2.2-1.4-3.2 c-1.2-1.2-2.6-1.3-4.5-2.1c-1.2-0.5-2-1.6-2.5-2.4c-1.1-1.7,0.3-2.9,1.6-2c1.7,1.3,2.4,2.1,4.2,2.7c2.1,0.7,4.6,0.4,5.6,0.2 C27.8,42.1,31,40.6,33.9,42.6"
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000029738867355321233410000002885188675840765854_",
    width: 61.1,
    height: 61
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000054247700046273440390000004445773175615423134_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000029738867355321233410000002885188675840765854_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000054247700046273440390000004445773175615423134_)",
      fill: "#44C8F5"
    },
    d: "M24.8,40.8 c-5.8,1.7-10.1,0.3-13.5-4.2C6.2,30,8.3,20,14.9,15c2.1-1.6,5.1-2.9,6.7-0.8c0.7,0.9,0.1,2-0.8,2.6c-2.1,1.6-3.2,1.8-5.3,3.4 c-1.6,1.2-2.3,3.4-1.1,5c1.1,1.5,3.3,0.6,4.8-0.5c0.9-0.6,1-0.6,2-1.2c1.3-0.8,2.5-1.3,3.2-0.2c0.9,1.3,0.7,1.9-0.5,2.9 c-2.3,1.9-3.7,2.8-6.7,4.4c-1.7,0.9-2.4,3.4-1.2,4.9c1.3,1.7,3.3,2.8,5.1,2.4c1.3-0.3,2.7-1.4,3.5-0.3 C25.5,38.5,26.1,40.4,24.8,40.8"
  })), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000035497702983417911330000004456772480999541951_",
    width: 61.1,
    height: 61
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000107586498765493948640000015562144766048236988_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000035497702983417911330000004456772480999541951_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000107586498765493948640000015562144766048236988_)",
      fill: "#44C8F5"
    },
    d: "M18.4,35.5 c0.7,0.6,1.6,0.9,2.4,0.3c0.9-0.7,1.2-2.1,0.4-3c-0.8-1-2.3-1.3-3.3-0.5C16.8,33.1,17.4,34.7,18.4,35.5"
  })), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000167363558685325391290000000441234345191260848_",
    width: 61.1,
    height: 61
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000042727264168815787450000010163551937420109994_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000167363558685325391290000000441234345191260848_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000042727264168815787450000010163551937420109994_)",
      fill: "#2F7DC1"
    },
    d: "M15.5,23.9 c0.5,0.7,1.7,0.3,2.4-0.2c0.9-0.7,1.4-1,2.2-1.7c1.8-1.3,4.4-2.3,5.7-0.5c1.2,1.6,1.2,3.9-0.3,5.1c-1.2,0.9-1.8,1.4-3,2.3 c-0.6,0.5-0.9,1.3-0.4,1.9c1.5,2,4.3-0.1,6.3-1.6s2.4-3.7,1.8-6.2c-0.4-1.6-2.4-3.2-3-4.8c-0.5-1.4,0.9-2.9,2.1-3.8 c1.4-1,3.4-0.1,5,0.5c1.6,0.6,2.9,1.8,4.2,0.8c0.8-0.6,0.8-1.8,0.2-2.7c-0.3-0.4-4.5-4-7.8-2.3c-1.3,0.7-1.8,2.3-3.5,2.7 c-2.6,0.5-3.5-4.4-5.9-3.3c-2.5,1.1,4.3,4.8,0.5,8c-0.9,0.8-1.6,0.9-2.7,1.5c-1.3,0.8-2.1,0.9-3.4,2C15.2,22,15,23.2,15.5,23.9"
  })), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000018207651896675575130000012248326327284765873_",
    width: 61.1,
    height: 61
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000112618396803175379370000001186080513964671930_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000018207651896675575130000012248326327284765873_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000112618396803175379370000001186080513964671930_)",
      fill: "#8DC63F"
    },
    d: "M31,31.9 c0.6,0.8,2,1.2,2.8,0.5c1.1-0.9,1.2-2.5,0.3-3.6s-2.5-0.9-3.6,0C29.5,29.6,30.3,31,31,31.9"
  })), /*#__PURE__*/React.createElement("g", null, _defs0 || (_defs0 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000094588803663420846530000001164260004330326957_",
    width: 61.1,
    height: 61
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085222128791468207820000006749034932236319391_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000094588803663420846530000001164260004330326957_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000085222128791468207820000006749034932236319391_)",
      fill: "#8DC63F"
    },
    d: "M32.5,23.6 c-1.1-1.4-1.7-2.2-2.8-3.6c-0.9-1.2-1.8-3-0.5-4c1.5-1.2,3-0.3,4.3,1.1c0.9,1,1.2,1.4,1.9,1.8c0.8,0.5,2.6,0.4,3.8-0.5 c0.9-0.6,1.4-1.5,1.6-2.3c0.7-2.8-2.9-4.5-2.1-5.6c0.8-1,2.3-0.2,3,0.2c1,0.6,3.3,1.7,3.7,3c0.8,2.5-1.9,3.8-0.7,5.7 c1.4,2,5.3,0.1,6.1,1.1c0.6,0.8,0.7,2-0.3,2.7c-1.8,1.4-8.3-0.9-10.1,0.4c-2.1,1.6-1,5.7-0.2,8.3c0.5,1.7,0,3.9-1.4,4.9 c-1.6,1.2-1.7-1.9-2.1-3.8C35.7,28.6,35,26.9,32.5,23.6"
  })), /*#__PURE__*/React.createElement("g", null, _defs1 || (_defs1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000041280746641743277950000014749105478926330286_",
    width: 61.1,
    height: 61
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000046317190143201585960000008916411123633262776_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000041280746641743277950000014749105478926330286_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000046317190143201585960000008916411123633262776_)",
      fill: "#2F7DC1"
    },
    d: "M28.2,11.9 c0.9-0.7,1.9-1.9,1.2-2.8C28.6,8,27,7.9,25.9,8.7c-0.6,0.5-1.2,1.3-0.8,2c0.4,0.6,0.9,1.4,1.6,1.5C27.1,12.3,27.8,12.2,28.2,11.9"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 61.1,
    height: 61
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M49.9,34.8c2.6,0.6,3.5-2.2,2.2-3.9C49.3,27.3,45.4,33.7,49.9,34.8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWftologo);
export default __webpack_public_path__ + "static/media/wftologo.b8146fc233ca0bd456b9330129f659e5.svg";
export { ForwardRef as ReactComponent };